import DashboardProvider from "providers/Schedule/DashboardProvider";
import ScheduleProvider from "providers/Schedule/ScheduleProvider";
import AuthProvider from "providers/Settings/AuthProvider";
import InventoryProvider from "providers/Settings/Inventory";
import ManagerProductProvider from "providers/Settings/ManagerProductProvider";
import ReceivingSectorProvider from "providers/Settings/ReceivingSector";
import UserAuth0Provider from "providers/Settings/UserAuthProvider";
import SupplierPurchaseProvider from "providers/Supplier/PurchaseProvider";
import ScheduleSupplierProvider from "providers/Supplier/ScheduleSupplierProvider";
import UserProvider from "providers/User/UserProvider";
import { FC, ReactNode } from "react";
import ReceivingSector from "views/admin/inventory/components/ReceivingStor";
import GeneralProvider from "./GeneralProvider";

interface SharedProviderProps {
  children: ReactNode;
}

const SharedProvider: FC<SharedProviderProps> = ({ children }) => {
  return (
    <AuthProvider>
      <UserAuth0Provider>
        <ReceivingSectorProvider>
          <UserProvider>
            <ScheduleProvider>
              <DashboardProvider>
                <GeneralProvider>
                  <SupplierPurchaseProvider>
                    <ScheduleSupplierProvider>
                      <ManagerProductProvider>
                        <InventoryProvider>{children}</InventoryProvider>
                      </ManagerProductProvider>
                    </ScheduleSupplierProvider>
                  </SupplierPurchaseProvider>
                </GeneralProvider>
              </DashboardProvider>
            </ScheduleProvider>
          </UserProvider>
        </ReceivingSectorProvider>
      </UserAuth0Provider>
    </AuthProvider>
  );
};

export default SharedProvider;
